import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TaxFormMeta {
  id: number;
  formType: string;
  fileName: string;
  version: number;
  generatedAt: string;
}

export interface FormsState {
  forms: TaxFormMeta[];
  isGenerating: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: FormsState = {
  forms: [],
  isGenerating: false,
  isLoading: false,
  error: null,
};

const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    setForms: (state, action: PayloadAction<TaxFormMeta[]>) => {
      state.forms = action.payload;
      state.error = null;
    },
    setIsGenerating: (state, action: PayloadAction<boolean>) => {
      state.isGenerating = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setFormsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearForms: (state) => {
      state.forms = [];
      state.error = null;
    },
  },
});

export const { setForms, setIsGenerating, setIsLoading, setFormsError, clearForms } = formsSlice.actions;
export default formsSlice.reducer;
